export enum FORGOT_PWD_STEP {
  INITIAL = "INITIAL",
  VALIDATE_OTP = "VALIDATE_OTP",
  RESEND_OTP = "RESEND_OTP",
  RESET = "RESET"
}
